// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__6FfD-","label":"Category_label__1Eaf_","content":"Category_content__3N3KY","header":"Category_header__3nyWD","location":"Category_location__90Pym"};